export var SINGULAR_LABEL = __('Row Selected');
export var PLURAL_LABEL = __('Rows Selected');
export var SINGULAR_COUNT = 1;